import { render, staticRenderFns } from "./StatusQuotation.vue?vue&type=template&id=94d10dfa&"
import script from "./StatusQuotation.vue?vue&type=script&lang=js&"
export * from "./StatusQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports